import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function AlanVaitzmanPage() {
  return <AttorneyBioTemplate attorney={attorneys['alan-vaitzman-esq']} />;
}
